<template>
    <div class="NotFoundScreen">
        <WText
            typo="h1"
            color="gray"
            :style="{ fontSize: '124px', lineHeight: '128px' }"
        >
            404
        </WText>
        <WText
            typo="h1"
            :style="{ fontSize: '60px', lineHeight: '64px' }"
        >
            {{ $t('error.404.title') }}
        </WText>
    </div>
</template>

<script>
export default {
    name: 'NotFoundScreen',
    metaInfo () {
        return {
            title: this.$t('error.404.title'),
        }
    },
}
</script>
<style lang="scss" scoped>
.NotFoundScreen {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 125px);
}
</style>
